import { Deferred } from '@/shared/libs';

export default (ctx, inject) => {
  const deferredLoader = {};
  deferredLoader.appReady = new Deferred();
  inject('deferredLoader', deferredLoader);
};
